import React, { useEffect } from 'react';

import globals from '../../../globals.json';

const CrossingInterstitial = props => {
    useEffect(() => {
        props.audioController.playAudioByName(props.data.audio);
        return () => props.audioController.removeAudio(props.data.audio);
    }, [])

    const mapRoute = (() => {
        // if QA bypasses route selection menu, we need to give a default map image
        if (props.currentRoute !== null) {
            return props.currentRoute
        } else {
            return props.tripId === 0 
                ? 'west'
                : props.tripId === 1 
                    ? 'southwest'
                    : 'midwest'
        }
    })();

    return (
        <div className={`CrossingInterstitial`}>
            <div className={`text-content`}>
                <h2>{props.data.header}</h2>
                <div className={`yellow-underline`} />
                <p>{props.data.body}</p>
            </div>
            <div className={`map-image ${mapRoute+'-'+(props.crossingId + 1)}`} />
            <div className={`bottom-left-orange`} />
            <div className={`global-button continue-button`} onClick={props.crossingComplete}>{globals.continueButtonText}</div>
        </div>
    )
}

export default CrossingInterstitial